import {
    CorporateFareIcon,
    DevicesFotaIcon,
    FileDraftOutlineIcon,
    GroupOutlineIcon,
    TaskGropsIcon,
    WebTaskGroupsIcon
} from "@dotnet/telematics-design-system";

import {
    CounterData,
    Link
} from "../../components/TableDetails/CompanyDetails/types/interfaces";
import { LINK_IDS, ROUTES } from "../types";

export const COUNTER_INITIAL_STATE: CounterData = {
    [LINK_IDS.Users]: 0,
    [LINK_IDS.Groups]: 0,
    [LINK_IDS.Files]: 0,
    [LINK_IDS.Devices]: 0,
    [LINK_IDS.Tasks]: 0,
    [LINK_IDS.ChildCompanies]: 0
};

export const LINKS: Link[] = [
    { id: LINK_IDS.Devices, path: ROUTES.Devices, icon: DevicesFotaIcon },
    { id: LINK_IDS.Tasks, path: ROUTES.TaskGroups, icon: TaskGropsIcon },
    { id: LINK_IDS.Groups, path: ROUTES.DeviceGroups, icon: WebTaskGroupsIcon },
    { id: LINK_IDS.Files, path: ROUTES.Files, icon: FileDraftOutlineIcon },
    { id: LINK_IDS.Users, path: ROUTES.Users, icon: GroupOutlineIcon },
    {
        id: LINK_IDS.ChildCompanies,
        path: ROUTES.Companies,
        icon: CorporateFareIcon
    }
];
